/*
 * File: c:\Users\j.mazat\Desktop\mobybuy_front\src\Hooks\useLocalStorage.tsx
 * Project: c:\Users\j.mazat\Desktop\mobybuy_front
 * Created Date: Thursday June 6th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 15th July 2024 04:28:59
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useState } from "react";

export const useLocalStorage = function <T>(keyName: string, defaultValue: T): [T, (newValue: T) => void] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue: T) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};
